/**
 * Created by Administrador on 24/04/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('economicActivities', {
                parent: 'app',
                url: '/economicActivity?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/economicActivity/economicActivities.html',
                        controller: 'economicActivityCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['economicActivity']);
                            }],
                            economicActivities: ['economicActivityService','$stateParams', function(economicActivityService,$stateParams){
                                return economicActivityService.getPageEconomicActivities($stateParams.page, $stateParams.size, true);
                            }]
                        }
                    }
                }
            })
            .state('economicActivityNew', {
                parent: 'app',
                url: '/economicActivity/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/economicActivity/newEconomicActivity.html',
                        controller: 'newEconomicActivityCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['economicActivity']);
                            }],
                            taxpayers: ['taxpayerService', function(taxpayerService){
                                return taxpayerService.getTaxpayers();
                            }]
                        }
                    }
                }
            })
            .state('economicActivityEdit', {
                parent: 'app',
                url: '/economicActivity/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/economicActivity/editEconomicActivity.html',
                        controller: 'editEconomicActivityCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['economicActivity']);
                            }],
                            economicActivity: ['economicActivityService', '$stateParams', function(economicActivityService, $stateParams) {
                                return economicActivityService.getEconomicActivity($stateParams.id);
                            }],
                            taxpayers: ['taxpayerService', function(taxpayerService){
                                return taxpayerService.getTaxpayers();
                            }]
                        }
                    }
                }
            })
            .state('economicActivityDelete', {
                parent: 'economicActivities',
                url: '/economicActivity/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/finance/economicActivity/deleteEconomicActivity.html',
                        controller: 'deleteEconomicActivityController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['economicActivity']);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('economicActivities', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
        .state('economicActivitySettings', {
            parent: 'app',
            url: '/economicActivity/:id/settings',
            data: {
                authorities: CONFIG.AUTHORITIES_ALL
            },
            views:{
                'main@':{
                    templateUrl: 'app/admin/finance/economicActivity/settingsEconomicActivity.html',
                    controller: 'settingsEconomicActivityCtrl',
                    controllerAs: 'vm',
                    resolve: {
                        translatePartialLoader: ['translationHandler', function (translationHandler) {
                            return translationHandler.translateRefresh(['economicActivity','operation']);
                        }],
                        economicActivity: ['economicActivityService', '$stateParams', function(economicActivityService, $stateParams) {
                            return economicActivityService.getEconomicActivity($stateParams.id);
                        }],
                        operations: ['operationService', '$stateParams', function(operationService) {
                            return operationService.getOperations(false);
                        }],
                        operationsNotInEconomicActivity: ['operationEconomicActivityService','$stateParams',
                            function(operationEconomicActivityService,$stateParams){
                                return operationEconomicActivityService.getOperationsNotInEconomicActivity($stateParams.id);
                            }],
                        operationsByEconomicActivity: ['operationEconomicActivityService','$stateParams',
                            function(operationEconomicActivityService,$stateParams){
                                return operationEconomicActivityService.getOperationsByEconomicActivity($stateParams.id);
                            }]
                    }
                }
            }
        });
    }
})();
